import axios from "axios";
import { API } from "@/lib/api";

export const papi = axios.create({ baseURL: API });

papi.interceptors.request.use((config) => {
  const token = localStorage.getItem("pnc_platform_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

papi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && localStorage.getItem("pnc_platform_token")) {
      localStorage.removeItem("pnc_platform_token");
      if (!window.location.pathname.includes("/platform/login")) window.location.href = "/platform/login";
    }
    return Promise.reject(err);
  }
);
